import { Heading } from "@freightsimple/ui-core/Typography/Heading";
import type { Shipment } from "@freightsimple/generated-dashboard-openapi-client/models/Shipment";

interface PickupNotesPageProp {
  shipment: Shipment;
}

export function ModifyShipmentPickupNotesPage(_props: PickupNotesPageProp) {
  return <Heading level={1}>Pickup Notes</Heading>;
}
